ACC.orderSearch = {
  datePickerInit: function(element) {
    if ($(element).length > 0 && $(element).is(':visible') && !$(element).hasClass('ph-dateInit')) {
      ACC.datePicker.datePickerInit($(element));
      $(element).addClass('ph-dateInit');
    }
  },
  hasDatePickerClass: 'input.hasDatepicker',
  setToDateAfterLoad: function() {
    if ($('#fromDate').is(':visible')) {
      var fromDateVal = $('#fromDate').datepicker('getDate');

      if (fromDateVal !== null) {
        var curDate = new Date(),
            addingDays = fromDateVal.addDays(30),
            setToDt = addingDays,
            $toDate = $('#toDate');

        if (addingDays > curDate) {
          setToDt = curDate;
        }

        $toDate.datepicker('setDate', setToDt);
        $toDate.datepicker('option', 'maxDate', setToDt);
      }
    }
  }

};
$(document).ready(function() {
  ACC.orderSearch.datePickerInit($('#fromDate'));
  ACC.orderSearch.datePickerInit($('#toDate'));
  $('#searchParameter').on('change', function() {
    setTimeout(function() {
      ACC.orderSearch.datePickerInit($('#fromDate'));
      ACC.orderSearch.datePickerInit($('#toDate'));
    }, 500);
  });

  $(ACC.orderSearch.hasDatePickerClass).blur(function() {
    var calIcon = $(ACC.orderSearch.hasDatePickerClass).parent().find('.cal_icon');

    calIcon.off('click');
    calIcon.click(function() {
      $(this).parent().parent().find(ACC.orderSearch.hasDatePickerClass).datepicker('show');
    });
  });

  ACC.orderSearch.setToDateAfterLoad();

  $('#searchOrderForm,#anonymousSearchOrderForm').validate({
    errorClass: 'error invalid_date',
    rules: {
      toDate: {
        required: false,
        dpDate: true,
        dpCompareDate: [
          'notLessThan',
          '#fromDate'
        ]
      },
      fromDate: {
        required: false,
        dpDate: true,
        dpCompareDate: [
          'notGreaterThan',
          '#toDate'
        ]
      }
    },
    messages: {
      toDate: {
        dpCompareDate: $('.ph-todate').html()
      },
      fromDate: {
        dpCompareDate: $('.ph-fromdate').html()
      }
    }
  });

  $('#searchOrderForm input').focus(function() {
    $('#instruction_text').removeClass('error');
    $('#instruction_text').addClass('hidden');
    $('#searchOrderForm .cal_icon').css('top', $('#toDate').offset().top);
  });

  $('.order-table a.order-link').click(function() {
    $('.order-table tr').removeClass('selected');
    $(this).parent().parent().addClass('selected');

    var containerid = $(this).attr('id') + '-container';

    $('.order-detail-container').hide();
    $('#' + containerid).show();
  });

  function emailPopup(data) {
    $.colorbox({
      html: $('.ph-emailpopup').html(),
      width: '100%',
      maxWidth: 480,
      height: '80%',
      maxHeight: 100,
      top: 50,
      close: '<button type=\'button\' id=\'ph-cboxClose\'><span class=\'ph-icon-cross\'></span></button>',
      onComplete: function() {
        ACC.common.refreshScreenReaderBuffer();
        $('.ph-spinnerorder').addClass('ph-d-none');

        if (data) {
          $('.invoiceEmailSent').addClass('ph-d-block');
          $('.invoiceEmailError').removeClass('ph-d-block');
        } else {
          $('.invoiceEmailError').addClass('ph-d-block');
          $('.invoiceEmailSent').removeClass('ph-d-block');
        }
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  }

  function invoiceAjax(formUrl) {
    $('.ph-spinnerorder').removeClass('ph-d-none');
    $.ajax({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json; charset=utf-8'
      },
      url: formUrl,
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        emailPopup(data);
      }
    });
  }

  $(document).on('click', '.ph__selfinvoiceno__click', function() {
    var entryNumber = $(this).attr('data-entryNumber'),
        rmdNumber = $(this).attr('data-rmdNumber'),
        selfInvoiceNumber = $.trim($(this).attr('data-selfInvoiceNumber')),
        ajaxpath = $(this).attr('data-selfinvoiceUrl') + '?rmdNumber=' + rmdNumber + '&entryNumber=' + entryNumber + '&selfInvoiceNumber=' + selfInvoiceNumber;

    invoiceAjax(ajaxpath);
  });

  $(document).on('click', '.ph__invoiceno__click', function() {
    var orderNumber = $(this).attr('data-orderNumber'),
        entryNumber = $(this).attr('data-entryNumber'),
        invoiceNumber = $.trim($(this).attr('data-invoiceNumber')),
        ajaxpath = $(this).attr('data-invoiceUrl') + '?orderNumber=' + orderNumber + '&entryNumber=' + entryNumber + '&invoiceNumber=' + invoiceNumber;

    invoiceAjax(ajaxpath);
  });

  $(document).on('click', '.ph__rmdnumber__click', function() {
    var rmdNumber = $(this).attr('data-rmdNumber'),
        ajaxpath = $(this).attr('data-rmddownloadUrl') + '?rmdNumber=' + rmdNumber;

    invoiceAjax(ajaxpath);
  });
});

/* eslint-disable no-implicit-globals */
function datePovalidation() {
  /* eslint-enable no-implicit-globals */

  var $purchasenumber = $('#purchaseOrderNumber');

  if ($.trim($purchasenumber.val()) !== '' && $.trim($('#fromDate').val()) !== '' && $.trim($('#toDate').val()) !== '') {
    return true;
  }

  return false;
}

/* eslint-disable no-implicit-globals */
function itemCheck(i) {
  /* eslint-enable no-implicit-globals */
  if (i.check === 'numeric') {
    return ACC.validation.numeric($.trim($(i.element).val()));
  } else if (i.check === 'alphanumericwithhyphen') {
    return ACC.validation.alphanumericwithhyphen($.trim($(i.element).val()));
  }

  return $.trim($(i.element).val()) === '';
}

/* eslint-disable no-implicit-globals */
function dataValidation(datatype) {
  /* eslint-enable no-implicit-globals */
  var count = 0,
      items = [
        {
          element: '#confirmationNumber',
          check: 'numeric'
        },
        {
          element: '#shipTo',
          check: 'numeric'
        },
        {
          element: '#materialNo',
          check: 'alphanumericwithhyphen'
        },
        {
          element: '#purchaseOrderNumber',
          check: ''
        }
      ];

  $.each(items, function(k, v) {
    if ($(v.element).is(':visible') && itemCheck(v)) {
      count = count + 1;
      $(v.element).parents('.error_holder').addClass('form_field_error').find('p').css('display', 'block');
    }
  });

  if (count === 0 && datatype === 'datavalidate') {
    return true;
  }

  $('#searchOrderForm .cal_icon').css('top', $('#toDate').offset().top);

  return false;
}

/* eslint-disable no-implicit-globals */
/* eslint-disable no-unused-vars */
function validateOrderSearchFrom() {
  /* eslint-enable no-implicit-globals */
  /* eslint-enable no-unused-vars */

  var $purchaseOrderNumber = $('input#purchaseOrderNumber'),
      $confirmationNumber = $('#confirmationNumber'),
      $shipTo = $('#shipTo'),
      $materialNo = $('#materialNo');

  $confirmationNumber.val($confirmationNumber.val().trim());
  $shipTo.val($shipTo.val().trim());
  $materialNo.val($materialNo.val().trim());
  $purchaseOrderNumber.val($purchaseOrderNumber.val().trim());

  $('.error_holder').removeClass('form_field_error').find('p').css('display', 'none');
  $('#searchOrderForm .cal_icon').css('top', $('#toDate').offset().top);

  if (datePovalidation() || ($.trim($('#fromDate').val()) !== '' && $.trim($('#toDate').val()) !== '') || ($.trim($confirmationNumber.val()) !== '')) {
    return dataValidation('datavalidate');
  }

  $('#instruction_text').removeClass('hidden');
  $('#instruction_text').removeClass('error').addClass('error');
  $('#searchOrderForm .cal_icon').css('top', $('#toDate').offset().top);

  return dataValidation('errordatavalidate');
}

$(document).ready(function() {
  $('.ph-searchagain').click(function() {
    var $primarysearchicon = $('.ph-headerparent__primarysearchicon'),
        colorchange = 'ph-colorchange';

    if ($('.ph-searchcomponent_input').length > 0) {
      $('.ph-searchcomponent_input').focus();
    } else if ($(window).width() <= 768) {
      $('.ph-hamburger__wrapper').toggleClass('hidden');
      $('.ph-searchparent input').focus();
    } else {
      $primarysearchicon.addClass(colorchange);
      $('.ph-searchparent__input').addClass('ph-colorchangeinput');
      $('.ph-searchboxbottom-onfocus').addClass('ph-d-lg-block');
      $('.ph-searchparent input').focus();
    }
  });

  $(document).on('change', '#searchOrderForm #searchParameter', function() {
    $('.ph-search__date #fromDate, .ph-search__date #toDate').val('');
  });
});
